// extracted by mini-css-extract-plugin
export default {"heading":"OA-z","corrected":"PA-z","redirectVerbiageContainer":"QA-z","redirectVerbiageText":"RA-z"};